var render = function render(_c,_vm){return _c('span',{staticClass:"next-number",attrs:{"data-level":_vm.props.level,"data-value":_vm.props.value,"data-type":_vm.props.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }